import { Component, Input } from '@angular/core';

import { fakeFunction } from '../../../../resources/consts';

@Component({
    selector: 'authorization-blocked',
    templateUrl: './authorization-blocked.component.html',
    styleUrls: ['./authorization-blocked.component.scss'],
})
export class AuthorizationBlockedComponent {
    @Input()
    public onCloseClick: () => void = fakeFunction;

    public handleClose(): void {
        this.onCloseClick();
    }
}
